import styled from 'styled-components';

import { media } from 'utils/detection';
import AwardCounter from 'components/AwardCounter';

export default styled(AwardCounter)`
  margin: 29px 0;

  ${media.medium`
    margin: 3vw 0;
  `}

  &:nth-child(odd) {
    margin-top: 80px;

    ${media.medium`
      margin-top: 8vw;
      margin-left: 22%;
      transform: translate(-50%, 0);
    `}
  }

  &:nth-child(even) {
    margin-left: auto;
    margin-right: 0;

    ${media.medium`
      margin-left: auto;
      margin-right: 8%;
    `}
  }
`;
